import { render } from "./LightboxGallery.vue?vue&type=template&id=440a341e"
import script from "./LightboxGallery.vue?vue&type=script&lang=js"
export * from "./LightboxGallery.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ognjenq/Sites/petarboats/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__